(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('FindClientsListController', FindClientsListController)

    FindClientsListController.$inject = ['clients','FindClientsService', 'ProfileTypeService','CountriesNewService', 'DeleteClientsService','$uibModal','$q', 'PlanService'];


    function FindClientsListController(clients, FindClientsService, ProfileTypeService, CountriesNewService, DeleteClientsService, $uibModal, $q, PlanService) {
        var vm = this;

        vm.clients                         = clients.data.data;
        vm.noResultMessage                 = '';
        vm.filter                          = {};
        vm.expoInstitutions                = [];
        vm.expoVirtualInstitution          = [];
        vm.webinars                        = [];
        vm.countriesNew                    = [];
        vm.nameSearch                      = [];
        vm.email                           = [];
        vm.country                         = [];
        vm.region                          = [];
        vm.city                            = [];
        vm.plan                            = [];
        vm.planExpiresOn                   = [
                                                {name:'All'},
                                                {name:'Expires on next 30 days'},
                                                {name:'Already expired'},
                                                {name:'Pending payment'}
                                             ];
        vm.typeSearchList                  = [
                                                {id:'agents',name:'Find Agents'},
                                                {id:'institutions',name:'Find Institutions'},
                                                {id:'governments',name:'Find Governments Agents'},
                                                {id:'others',name:'Find Others'}
                                             ];

        vm.countryLocationOperateSelected  = [];
        vm.countryWithBranchSelected       = [];
        vm.countryBasedSelected            = [];
        vm.countryRepresentSelected        = [];
        vm.profileTypeSelectedInstitutions = [];
        vm.profileTypeSelectedAgents       = [];
        vm.activeSelected                  = {name:'All'};
        vm.preApprovedSelected             = {name:'All'};
        vm.approvedSelected                = {name:'All'};
        vm.disabledSelected                = {name:'No'};

        vm.countrySelected                 = [];
        vm.regionSelected                  = [];
        vm.citySelected                    = [];
        vm.planSelected                    = [];
        vm.planExpiresOnSelected           = {name:'All'};
        vm.getByFilter                     = getByFilter;
        vm.processQuery                    = processQuery;

        vm.selectCountriesNew              = selectCountriesNew;
        vm.profileType                     = [];
        vm.typeSearch                      = {id:false};
        vm.active                          = [{name:'All'}, {name:'Yes'}, {name:'No'}];
        vm.preApproved                     = [{name:'All'}, {name:'Yes'}, {name:'No'}];
        vm.approved                        = [{name:'All'}, {name:'Yes'}, {name:'No'}];
        vm.disabled                        = [{name:'All'}, {name:'Yes'}, {name:'No'}];
        vm.selectCountry                   = selectCountry;
        vm.selectRegion                    = selectRegion;
        vm.selectCity                      = selectCity;
        vm.selectedCountry                 = selectedCountry;
        vm.selectPlans                     = selectPlans;
        vm.selectedRegion                  = selectedRegion;
        vm.openInformation                 = openInformation;
        vm.selectProfileType               = selectProfileType;
        /*PAGINATION*/
        vm.pageChanged                     = pageChanged;
        vm.setPage                         = setPage;
        vm.to                              = [];
        vm.totalItems                      = [];
        vm.currentPage                     = null;
        vm.itemsPerPage                    = [];
        vm.page                            = 1;
        vm.changeType                      = changeType;
        vm.openEditModal                   = openEditModal;
        vm.toggleApproved                  = toggleApproved;
        vm.openAdminModal                  = openAdminModal;
        vm.openObservationModal            = openObservationModal;
        vm.remove                          = remove;
        vm.blacklist                       = blacklist;

        function activate() {
            vm.selectCountry();
            vm.selectPlans();
            vm.selectProfileType();
        }

        function selectProfileType() {
            ProfileTypeService.getProfilesType().then(function(response){
                vm.profileType   = response.data;
            }).catch(function(err) {

            });
        }

        /* DYNAMIC SELECT OF INSTITUTION */
        function selectCountry () {
            CountriesNewService.getCountries().then(function(response){
                vm.country = response.data;
                vm.country.unshift({id:0,name:"All"});
            }).catch(function(err) {

            });
        }

        function selectPlans () {
            PlanService.getPlans().then(function(response){
                vm.plan = response.data;
                vm.plan.unshift({id:0,friendly_name:"All"});
            }).catch(function(err) {

            });
        }

        function selectRegion (country_id) {
            CountriesNewService.getRegions(country_id).then(function(response){
                vm.regionSelected   = [];
                vm.citySelected     = [];
                vm.city             = [];
                vm.region           = response.data;

            }).catch(function(err) {

            });
        }

        function selectCity (country_id, region_id) {
            CountriesNewService.getCities(country_id, region_id).then(function(response){
                vm.citySelected = [];
                vm.city   = response.data;

            }).catch(function(err) {

            });
        }

        function selectedCountry() {
            vm.selectRegion(vm.countrySelected['id']);
        }

        function selectedRegion() {
            vm.selectCity(vm.countrySelected['id'], vm.regionSelected['id']);
        }


        /* DYNAMIC SELECT OF AGENTS */
        function selectCountriesNew () {
            CountriesNewService.getCountries().then(function(response){
                vm.countriesNew = response.data;
            }).catch(function(err) {

            });
        }

        function processQuery() {
            FindClientsService.processQuery(vm.filter).then(function(response){
                    vm.clients = response.data.data;
                }).catch(function(err) {

                });
        }

        function getByFilter() {
            /* FIXME - Add in the search */
            vm.filter.profileType   = vm.profileTypeSelectedInstitutions;
            vm.query                = {};
            vm.query['type']        = vm.typeSearch.id;

            /*reset fields when change the input Type*/
            if(vm.typeSearch.id == 'institutions') {
                /*RESET COMMON FIELDS IN AGENTS OR GOVERNAMENTS*/
                vm.countryLocationOperateSelected   = [];
                vm.countryWithBranchSelected        = [];
                vm.countryBasedSelected             = [];
                vm.countryRepresentSelected         = [];

                /* SET FIELD PROFILE TYPE FOR INSTITUTIONS */
                vm.query['institutions_search_data.profile_type'] = [];
                if(typeof vm.profileTypeSelectedInstitutions !== 'undefined') {
                    angular.forEach(vm.profileTypeSelectedInstitutions, function(value, key) {
                        vm.query['institutions_search_data.profile_type'].push(value.alias);
                    });
                }
            }

            if(vm.typeSearch.id == 'agents') {
                /*RESET COMMON FIELDS IN INSTITUTIONS OR GOVERNAMENTS*/
                vm.countrySelected                  = [];
                vm.regionSelected                   = [];
                vm.citySelected                     = [];
                vm.profileTypeSelectedInstitutions  = [];
                vm.countryBasedSelected             = [];
                vm.countryRepresentSelected         = [];

                /* SET FIELD PROFILE TYPE FOR AGENTS */
                vm.query['agents_search_data.profile_type']=[];
                if(typeof vm.profileTypeSelectedAgents !== 'undefined') {
                    angular.forEach(vm.profileTypeSelectedAgents, function(value, key) {
                        vm.query['agents_search_data.profile_type'].push(value.alias);
                    });
                }
            }

            if(vm.typeSearch.id == 'governments') {
                /*RESET COMMON FIELDS IN AGENTS OR INSTITUTIONS */
                vm.countryLocationOperateSelected   = [];
                vm.countryWithBranchSelected        = [];
                vm.countrySelected                  = [];
                vm.regionSelected                   = [];
                vm.citySelected                     = [];
                vm.profileTypeSelectedInstitutions  = [];

            }

            if(vm.typeSearch.id == 'others') {
                /*RESET COMMON FIELDS IN AGENTS, INSTITUTIONS, GOVENMENTS */
                vm.countryLocationOperateSelected   = [];
                vm.countryWithBranchSelected        = [];
                vm.countrySelected                  = [];
                vm.regionSelected                   = [];
                vm.citySelected                     = [];
                vm.profileTypeSelectedInstitutions  = [];
                vm.countryBasedSelected             = [];
                vm.countryRepresentSelected         = [];
            }

            /* AGENTS */
            if(typeof vm.countryLocationOperateSelected.id !== 'undefined' && vm.countryLocationOperateSelected.name !== 'All') {
                vm.query['agents_search_data.countries_id'] = vm.countryLocationOperateSelected.id;
            }

            if(typeof vm.countryWithBranchSelected.id !== 'undefined' && vm.countryWithBranchSelected.name !== 'All') {
                vm.query['agents_search_data.branchs_countries_id'] = vm.countryWithBranchSelected.id;
            }

            /***** INSTITUTIONS */
            if(typeof vm.countrySelected.id !== 'undefined' && vm.countrySelected.name !== 'All') {
                vm.query['institutions_search_data.campus_countries'] = vm.countrySelected.id;
            }

            if(typeof vm.regionSelected.id !== 'undefined' && vm.regionSelected.name !== 'All') {
                vm.query['institutions_search_data.campus_regions'] = vm.regionSelected.id;
            }

            if(typeof vm.citySelected.name !== 'undefined') {
                vm.query['institutions_search_data.campus_cities'] = vm.countrySelected.id+'::'+vm.regionSelected.id+'::'+vm.citySelected.name;
            }

            /***** GOVERNAMENTS */
            if(typeof vm.countryBasedSelected.id !== 'undefined' && vm.countryBasedSelected.name !== 'All') {
                vm.query['governments_profile.based_country'] = vm.countryBasedSelected.id;
            }

            if(typeof vm.countryRepresentSelected.id !== 'undefined' && vm.countryRepresentSelected.name !== 'All') {
                vm.query['governments_profile.represent_country'] = vm.countryRepresentSelected.id;
            }

            /****** COMMONS FIELDS FOR INSTITUTIONS OR AGENTS */

            if(vm.typeSearch.id !== 'governments' && vm.typeSearch.id !== 'others') {
                if (typeof vm.nameSearch !== 'undefined' && vm.nameSearch.length !== 0) {
                    vm.query[vm.typeSearch.id + '_profile.name'] = vm.nameSearch;
                }

                if (typeof vm.email !== 'undefined' && vm.email.length !== 0) {
                    vm.query[vm.typeSearch.id + '_search_data.email'] = vm.email;
                }

                if (typeof vm.activeSelected.name !== 'undefined' && vm.activeSelected.length !== 0) {
                    if (vm.activeSelected.name !== 'All')
                        vm.query[vm.typeSearch.id + '_search_data.active'] = vm.activeSelected.name === 'Yes' ? 1 : 0;
                }

                if (typeof vm.approvedSelected.name !== 'undefined' && vm.approvedSelected.length !== 0) {
                    if (vm.approvedSelected.name !== 'All')
                        vm.query[vm.typeSearch.id + '_search_data.approved'] = vm.approvedSelected.name === 'Yes' ? 1 : 0;
                }

                if (typeof vm.preApprovedSelected.name !== 'undefined' && vm.preApprovedSelected.length !== 0) {
                    if (vm.preApprovedSelected.name !== 'All')
                        vm.query[vm.typeSearch.id + '_profile.pre_approved'] = vm.preApprovedSelected.name === 'Yes' ? 1 : 0;
                }

                if (typeof vm.disabledSelected.name !== 'undefined' && vm.disabledSelected.length !== 0) {
                    if (vm.disabledSelected.name !== 'All')
                        vm.query[vm.typeSearch.id + '_search_data.disabled'] = vm.disabledSelected.name === 'Yes' ? 1 : 0;
                }
            } else {
                if (typeof vm.nameSearch !== 'undefined' && vm.nameSearch.length !== 0) {
                    vm.query[vm.typeSearch.id + '_profile.name'] = vm.nameSearch;
                }

                if (typeof vm.email !== 'undefined' && vm.email.length !== 0) {
                    vm.query['users.email'] = vm.email;
                }

                if (typeof vm.activeSelected.name !== 'undefined' && vm.activeSelected.length !== 0) {
                    if (vm.activeSelected.name !== 'All')
                        vm.query['users.active'] = vm.activeSelected.name === 'Yes' ? 1 : 0;
                }

                if (typeof vm.approvedSelected.name !== 'undefined' && vm.approvedSelected.length !== 0) {
                    if (vm.approvedSelected.name !== 'All')
                        vm.query[vm.typeSearch.id + '_profile.approved'] = vm.approvedSelected.name === 'Yes' ? 1 : 0;
                }

                if (typeof vm.preApprovedSelected.name !== 'undefined' && vm.preApprovedSelected.length !== 0) {
                    if (vm.preApprovedSelected.name !== 'All')
                        vm.query[vm.typeSearch.id + '_profile.pre_approved'] = vm.preApprovedSelected.name === 'Yes' ? 1 : 0;
                }

                if (typeof vm.disabledSelected.name !== 'undefined' && vm.disabledSelected.length !== 0) {
                    if (vm.disabledSelected.name !== 'All')
                        vm.query['users.disabled'] = vm.disabledSelected.name === 'Yes' ? 1 : 0;
                }
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            if(typeof vm.planSelected.id !== 'undefined' && vm.planSelected.id !== 'All') {
                vm.query['users_plans.id'] = vm.planSelected.id;
            }

            if(typeof vm.planExpiresOnSelected.name !== 'undefined' && vm.planExpiresOnSelected.name !== 'All') {
                if(vm.planExpiresOnSelected.name == 'Expires on next 30 days')
                    vm.query['users_plans.expires_in'] = '30 days';
                if(vm.planExpiresOnSelected.name == 'Already expired' || vm.planExpiresOnSelected.name == 'Pending payment')
                    vm.query['users_plans.expires_in'] = vm.planExpiresOnSelected.name;
            }

            FindClientsService.getByFilter(vm.query, vm.page).then(function(response){
                vm.clients = response.data.data;
                if(vm.clients.length == 0)
                    vm.noResultMessage = 'Sorry, no results were found!';
                else
                    vm.noResultMessage = '';
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;

            }).catch(function(err) {

            });
        }

        function toggleApproved(client, type) {
            var request = [];
            if(vm.typeSearch.id == 'governments' || vm.typeSearch.id == 'others')
                request['user_id']  = client.users_id;
            else
                request['user_id']  = client.user_id;
            request['approved'] = client.approved;
            request['type']     = vm.typeSearch.id;

            FindClientsService.toggleApproved(request).then(function(response) {
                client.approved = response.data;
            });
        }

        function openInformation(client) {

            $uibModal.open({
                templateUrl: 'templates/edufindme/showInformation/template.modal.html',
                controller: 'OpenInformationEdufindmeController',
                controllerAs:'vm',
                resolve: {
                    client: function () {
                            var id;

                            if(vm.typeSearch.id == 'agents' || vm.typeSearch.id == 'institutions')
                                id = client.id;
                            else
                                id = client.users_id;

                            var serviceSearch = FindClientsService.getExpo(id, vm.typeSearch.id);
                            return serviceSearch.then(function(response){
                                client.expos = response.data;
                                return FindClientsService.getExpoVirtual(id, vm.typeSearch.id);
                            }).then(function(response) {
                                client.expoVirtual = response.data;
                                return FindClientsService.getWebinars(id, vm.typeSearch.id);
                            }).then(function(response) {
                                client.webinars = response.data;
                                return FindClientsService.getGeneralInformation(id, vm.typeSearch.id);
                            }).then(function(response){
                                client.generalInfo = response.data;
                                return client;
                            }).catch(function(err) {
                                return err;
                            });
                    }

                }
            });
        }

        function openEditModal(client, type) {

            $uibModal.open({
                templateUrl: 'templates/edufindme/findClients/edit/template.modal.html',
                controller: 'EditModalController',
                controllerAs:'vm',
                resolve:
                {
                    client      : function () {
                                    return client;
                                  },
                    type  : function () {
                                    return type;
                                  },
                }
            });
        }

        function openAdminModal(client, type) {
            $uibModal.open({
                templateUrl: 'templates/edufindme/findClients/admin/template.modal.html',
                controller: 'AdminEdufindmeController',
                controllerAs:'AdminEdufindme',
                resolve:
                {
                    client      : function () {
                        return client;
                    },
                    type  : function () {
                        return type;
                    },
                }
            });
        }

        function openObservationModal(client, type) {
            $uibModal.open({
                templateUrl: 'templates/edufindme/findClients/observation/template.modal.html',
                controller: 'ObservationsEdufindmeController',
                controllerAs:'ObservationsEdufindme',
                resolve:
                    {
                        client      : function () {
                            return client;
                        },
                        type  : function () {
                            return type;
                        },
                    }
            });
        }

        function changeType() {
            vm.page = 1;
                vm.clients = [];
                /*RESET COMMON FIELDS IN AGENTS OR GOVERNAMENTS*/
                vm.nameSearch   = [];
                vm.email   = [];

                vm.countryLocationOperateSelected   = [];
                vm.countryWithBranchSelected        = [];
                vm.countryBasedSelected             = [];
                vm.countryRepresentSelected         = [];
                vm.planSelected                     = [];

                /*RESET COMMON FIELDS IN INSTITUTIONS OR GOVERNAMENTS*/
                vm.countrySelected                  = [];
                vm.regionSelected                   = [];
                vm.citySelected                     = [];
                vm.profileTypeSelectedInstitutions  = [];
                vm.countryBasedSelected             = [];
                vm.countryRepresentSelected         = [];


                /*RESET COMMON FIELDS IN AGENTS OR INSTITUTIONS */
                vm.countryLocationOperateSelected   = [];
                vm.countryWithBranchSelected        = [];
                vm.countrySelected                  = [];
                vm.regionSelected                   = [];
                vm.citySelected                     = [];
                vm.profileTypeSelectedInstitutions  = [];

                /*RESET COMMON FIELDS IN AGENTS, INSTITUTIONS, GOVENMENTS */
                vm.countryLocationOperateSelected   = [];
                vm.countryWithBranchSelected        = [];
                vm.countrySelected                  = [];
                vm.regionSelected                   = [];
                vm.citySelected                     = [];
                vm.profileTypeSelectedInstitutions  = [];
                vm.countryBasedSelected             = [];
                vm.countryRepresentSelected         = [];

            vm.totalItems       = '';
            vm.to               = '';
            vm.itemsPerPage     = '';
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();

        }

        function remove (client, type) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this user ' + client.name+'?')
                .set('onok', function (){
                    var idOfClient;

                    if(type==='institutions' || type==='agents')
                        idOfClient = client.id;
                    else
                        idOfClient = client.users_id;

                    DeleteClientsService.deleteClient(idOfClient, type).then(function () {
                        vm.clients.splice(vm.clients.indexOf(client), 1);
                        alertify.notify('Usuário apagado', 'success', 3);
                    });
                })
                .show();
        }

        function blacklist(client)
        {
            var message = (client.blacklist.length > 0 ? 'Do you really want to remove "' + client.name+'" from the blacklist?' : 'Do you really want to include "' + client.name+'" in the blacklist?');

            alertify
                .confirm(message)
                .set('labels', {
                    ok: 'Confirm',
                    cancel: 'Cancel'
                })
                .set('title', 'Attention')
                .set('onok', function (){
                    vm.query = {};
                    vm.query['client'] = client;
                    FindClientsService.blacklist(vm.query).then(function (response) {
                        client.blacklist = response.data;
                        console.log(response);
                        //vm.clients.splice(vm.clients.indexOf(client), 1);
                        //alertify.notify('Usuário apagado', 'success', 3);
                    });
                })
                .show();
        }

        activate();
    }

})();